var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete_icon",
    "data-name": "Delete icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5047",
    "data-name": "Group 5047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5046",
    "data-name": "Group 5046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M10,20A10,10,0,1,1,20,10,10.029,10.029,0,0,1,10,20ZM10,1.667A8.333,8.333,0,1,0,18.333,10,8.358,8.358,0,0,0,10,1.667Z",
    fill: "#5f636b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049",
    transform: "translate(5.833 5.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5048",
    "data-name": "Group 5048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M7.833,15.333a.757.757,0,0,1-.583-.25.806.806,0,0,1,0-1.167L13.917,7.25a.825.825,0,0,1,1.167,1.167L8.417,15.083A.757.757,0,0,1,7.833,15.333Z",
    transform: "translate(-7 -7)",
    fill: "#5f636b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051",
    transform: "translate(5.833 5.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M14.5,15.333a.757.757,0,0,1-.583-.25L7.25,8.417A.825.825,0,0,1,8.417,7.25l6.667,6.667a.806.806,0,0,1,0,1.167A.757.757,0,0,1,14.5,15.333Z",
    transform: "translate(-7 -7)",
    fill: "#5f636b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelChatIcon);
export default __webpack_public_path__ + "static/media/cancel-chat-icon.1fdb452b288bfd07a7f059486212dba7.svg";
export { ForwardRef as ReactComponent };